import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "@/services/axiosConfig";
 
const shipProfile = createAsyncThunk("ship/shipProfile", async () => {
    const { data } = await instance.get(
      `ships/info`
    );
     return data;
  });
  
  export { shipProfile };
